import googleLogo from '@/components/PlatformIcon/icons/google.png';
import { PlatformTypes } from '@/types/gql.generated';
import { useAlwaysAvailable } from './availability.lib';
import type { DestinationModule } from './types';

// The weblink flavor of Google. Pickers never offer it — they offer the
// integration and let the auth flow decide — so it lives only in the weblink
// menus (isPickerHidden), where it reads 'Google Calendar' to distinguish it
// from the direct integration.
export const googleLinkDestination: DestinationModule = {
  platform: PlatformTypes.GoogleLink,
  behavior: 'copy',
  name: 'Google',
  addLabel: 'Add to Google',
  menuLabel: 'Google Calendar',
  icon: { kind: 'image', src: googleLogo },
  isPinnable: true,
  persistedByServer: false,
  statusSource: 'localOnly',
  isPickerHidden: true,
  useIsAvailable: useAlwaysAvailable,
  weblink: { urlKey: 'google' },
};
